import { Component, ComponentInterface, JSX, Prop, h } from '@stencil/core';
import { bannerService } from 'app/shared/services/banner/banner.service';

@Component({
  tag: 'app-banner-progress-indicator',
  styleUrl: 'banner-progress-indicator.scss'
})
export class BannerProgressIndicator implements ComponentInterface {
  @Prop() public readonly dataSpa: string = null;

  render(): JSX.Element {
    return (
      <agl-ds-h1
        class="progress-indicator-text"
        styled-as="title6"
        bottom-margin="none"
        appearance="muted"
        data-testid="banner-progress-indicator"
      >
        {bannerService.getBannerTitle(this.dataSpa)}
      </agl-ds-h1>
    );
  }
}
